import StepsProgress from './StepsProgress';

export default StepsProgress;
